import React from "react";
import { ArrowUpRight } from "lucide-react";
import { companyInfo, navLinks } from "../mock";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="icg-dark pt-24 pb-10">
      <div className="icg-container">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="icg-dot" />
              <span className="font-display font-semibold text-lg">{companyInfo.name}</span>
            </div>
            <h3 className="mt-8 font-display font-semibold tracking-tight"
                style={{ fontSize: "clamp(36px, 5vw, 72px)", lineHeight: 1 }}>
              Ready to stand<br />
              out from the <span className="font-serif-it text-[color:var(--icg-accent)]">crowd?</span>
            </h3>
            <a href="/#contact" className="mt-8 inline-flex icg-btn" style={{ background: "var(--icg-accent)", color: "var(--icg-ink)" }}>
              Start a project <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-[color:var(--icg-cream)]/50">Navigate</div>
            <ul className="mt-4 space-y-2">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-[color:var(--icg-cream)]/80 hover:text-[color:var(--icg-accent)] transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-[color:var(--icg-cream)]/50">Contact</div>
            <ul className="mt-4 space-y-2 text-[color:var(--icg-cream)]/80">
              <li><a href={`mailto:${companyInfo.email}`} className="hover:text-[color:var(--icg-accent)] transition-colors">{companyInfo.email}</a></li>
              <li><a href={`tel:${companyInfo.phone}`} className="hover:text-[color:var(--icg-accent)] transition-colors">{companyInfo.phone}</a></li>
              <li>{companyInfo.address}</li>
              <li className="text-[color:var(--icg-cream)]/60">{companyInfo.workingHours}</li>
            </ul>
          </div>
        </div>

        <div className="icg-divider mt-16 mb-6" />
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-[color:var(--icg-cream)]/60">
          <div>© {year} {companyInfo.name} {companyInfo.suffix}. Founded by {companyInfo.founder} in {companyInfo.foundedYear}.</div>
          <div>Dallas · Detroit · Chandigarh</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
